import React from "react"
import { graphql, Link } from "gatsby"
import SEO from "../../components/seo"
import Layout from "../../components/layout"
import Hero from "../../components/hero"
import Categories from "../../components/categories"
import PostBody from "../../components/postBody"
import PostSidebar from "../../components/postSidebar"
import ReadingTime from "../../helpers/timeToRead"
import { findFirstSectionVideo } from "../../helpers/findFirstSectionVideo"

export const query = graphql`
  query($slug: String) {
    sanityBlog(slug: { current: { eq: $slug } }) {
      title
      slug {
        current
      }
      category {
        slug {
          current
        }
        title
      }
      showFilter
      publishDate(formatString: "Do MMMM, YYYY")
      datePublished: _createdAt
      dateModified: _updatedAt
      author {
        name
      }
      _rawIntro
      _rawBody(resolveReferences: { maxDepth: 10 })
      form {
        title
        formLink
      }
      seo {
        metaTitle
        canonical
        description
        noIndex
        openGraphImage {
          asset {
            url
          }
        }
      }
    }
    sanityBlogListing {
      blogListingSettings {
        breadcrumbTitle
      }
    }
  }
`

const BlogTemplate = ({ data }) => {
  const post = data.sanityBlog
  const postUrl = `/blog/${post.category.slug.current}/${post.slug.current}/`

  const embedUrl = findFirstSectionVideo(post?._rawBody)
  const video = embedUrl && { embedUrl }

  const breadcrumbTitle =
    data.sanityBlogListing.blogListingSettings.breadcrumbTitle

  return (
    <Layout>
      <SEO
        isBlogPost
        title={post.title}
        path={postUrl}
        author={post.author?.name}
        datePublished={post.datePublished}
        dateModified={post.dateModified}
        video={video}
        {...post.seo}
      />
      <Hero title={post.title}>
        <p>
          <Link to="/">Home</Link> <Link to="/blog/">{breadcrumbTitle}</Link>
        </p>
      </Hero>
      <div className="grid">
        <div className="gridItem large-3">
          <PostSidebar>
            <p>
              {post.publishDate}
              {post.author && ` by ${post.author.name}`}
            </p>
            <p>
              Reading time: <ReadingTime {...post._rawBody} />
            </p>
            {post?.showFilter && <Categories postType="blog" />}
          </PostSidebar>
        </div>
        <div className="gridItem large-8">
          <PostBody
            content={post._rawBody}
            intro={post._rawIntro}
            form={post.form}
          />
        </div>
      </div>
    </Layout>
  )
}

export default BlogTemplate
